module.exports = __webpack_public_path__ + "img/upload-image-exists.1f40d23b.svg";